import { ISettings } from '@admin/pages/settings-manager/interfaces/settings.interface';
import { NewsletterDialogComponent } from '@core/newletter-dialog/newsletter-dialog.component';
import { SearchCertificateDialogComponent } from '@core/search-certificate-dialog/search-certificate-dialog.component';
import { ModalUtilsService } from '@core/services/modal-utils.service';
import {
  faCcAmex,
  faCcApplePay,
  faCcMastercard,
  faCcPaypal,
  faCcVisa,
  faFacebookF,
  faGooglePay,
  faInstagram,
  faLinkedinIn,
  faTiktok,
  faTwitter,
} from '@fortawesome/free-brands-svg-icons';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LanguageService } from '@shared/services/language.service';
import { PublicGenericService } from '@shared/services/public-generic.service';
import { Group } from '../../../pages-manager/interfaces/pages.interface';
import { PagesService } from '../../../pages-manager/services/pages.service';
import { SellerBrandingService } from '../../../seller/services/seller-branding.service';

import {
  Component,
  Input,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [
        FontAwesomeModule,
        TranslateModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
    ]
})
@UntilDestroy()
export class FooterComponent {
  faInstagram = faInstagram;
  faFacebookF = faFacebookF;
  faTikTok = faTiktok;
  faTwitter = faTwitter;
  faLinkedinIn = faLinkedinIn;
  faCcPaypal = faCcPaypal;
  faCcVisa = faCcVisa;
  faCcMastercard = faCcMastercard;
  faCcAmex = faCcAmex;
  faCcApplePay = faCcApplePay;
  faGooglePay = faGooglePay;

  pagesList: Array<Group> = [];
  pagesCol1: Array<Group> = [];
  pagesCol2: Array<Group> = [];
  footerPages: Array<{ slug?: string; pageRoute?: string; pageName: string }> =
    [];
  isBranded = computed(() => this.branding.isBranded());

  currLang = signal('');

  email: string;

  @Input() appSettings: ISettings;
  @Input() showAll: boolean = true;

  socialLinks = computed(() => ({
    urlFacebook: this.appSettings.urlFacebook,
    urlTwitter: this.appSettings.urlTwitter,
    urlInstagram: this.appSettings.urlInstagram,
    urlLinkedin: this.appSettings.urlLinkedin,
    urlTiktok: this.appSettings.urlTiktok,
    ...(this.isBranded() ? this.branding.getAppSettings() : {}),
  }));

  private readonly pagesService = inject(PagesService);
  public readonly publicGenericService = inject(PublicGenericService);
  private readonly modalUtils = inject(ModalUtilsService);
  private readonly languageService = inject(LanguageService);
  private readonly branding = inject(SellerBrandingService);

  constructor() {
    this.languageService.selectedLanguage$
      .pipe(untilDestroyed(this))
      .subscribe((lang) => {
        this.currLang.set(lang.code);
      });

    effect(
      () => {
        if (this.currLang()) {
          this.loadFooter(this.currLang());
        }
      },
      { allowSignalWrites: true }
    );
  }

  private loadFooter(languageCode: string) {
    if (this.showAll) {
      // original full footer logic
      this.pagesService
        .getGroups(this.branding.activeSeller()?.idEntity || 1)
        .pipe(untilDestroyed(this))
        .subscribe((dataR) => {
          this.pagesList = dataR.map((group) => ({
            ...group,
            pageGroupList: group.pageGroupList.map((x) => ({
              ...x,
              languagePath: languageCode + '/' + x.pageRoute,
            })),
          }));
          this.pagesCol1 =
            this.pagesList?.filter((x) => x.colNumber === 1) ?? [];
          this.pagesCol2 =
            this.pagesList?.filter((x) => x.colNumber !== 1) ?? [];
        });
    } else {
      this.footerPages = [];
    }
  }

  // goToPage(route: string) {
  //   this.router.navigate([route]);
  // }

  onSubmit() {
    const ref = this.modalUtils.openModal(NewsletterDialogComponent, {
      size: 'lg',
      keyboard: false,
    });
    ref.componentInstance.email = this.email;
  }

  certificateDialog() {
    this.modalUtils.openModal(SearchCertificateDialogComponent, {
      size: 'lg',
      keyboard: false,
    });
  }
}
